import { useMutation } from "@tanstack/react-query";
import http from "@/common/axios";
import { getGlobalUserId, identifyUser } from "@/lib/amplitude";
import { captureException } from "@sentry/react";

interface MapUserRequest {
  user_id: number;
  global_user_id: string;
}

async function mapAmplitudeUser(request: MapUserRequest): Promise<void> {
  await http.post("/whatsapp/flow/amplitude/map-user", request);
}

/**
 * Hook to map anonymous Amplitude events to an authenticated user.
 * Should be called after successful authentication when the backend user ID is available.
 */
export default function useAmplitudeUserMapping() {
  return useMutation({
    mutationFn: async (backendUserId: number) => {
      const globalUserId = getGlobalUserId();

      // Call backend to map the user
      await mapAmplitudeUser({
        user_id: backendUserId,
        global_user_id: globalUserId,
      });

      // Set the user ID in Amplitude client
      identifyUser(String(backendUserId));
    },
    onError: (error) => {
      // Log error but don't block the user flow
      console.error("Failed to map Amplitude user:", error);
      captureException(error);
    },
  });
}
